import { msalConfig } from '../../authConfig'
import { PublicClientApplication } from '@azure/msal-browser'

export const msalInstance = new PublicClientApplication(msalConfig)
export const API_SCOPES = ['api://8a97f476-d0b7-4754-bf13-88a08e03ff54/access_as_user']

// Initialize MSAL instance - must be called before any MSAL operations
export const initializeMsal = async () => {
  await msalInstance.initialize()
  await msalInstance.handleRedirectPromise()
}
